import type { ReactNode } from "react";

interface HudPanelProps {
  label: string;
  rightLabel?: string;
  children?: ReactNode;
  className?: string;
}

export function HudPanel({ label, rightLabel, children, className = "" }: HudPanelProps) {
  return (
    <div
      className={`rounded-sm border border-line bg-[rgba(3,22,30,0.55)] px-3 py-2 shadow-[0_0_18px_rgba(0,229,255,0.06)] backdrop-blur-sm ${className}`}
    >
      <div className="mb-1.5 flex items-center justify-between font-mono text-[10px] tracking-[0.24em] text-cyan-dim uppercase">
        <span>{label}</span>
        {rightLabel && <span className="text-cyan/80">{rightLabel}</span>}
      </div>
      {children && <div className="text-xs text-text">{children}</div>}
    </div>
  );
}